import { useState } from 'react';
import { record } from "@solimat/solimat-web-endpoint";

const useUpdateDeclaracionJuradaCeseActividadObjetivaByID = () => {
  const [loadingUpdateDeclaracionJuradaCeseActividadObjetivaById, setLoadingCreateDeclaracionJuradaCeseActividadObjetiva] = useState(false);
  const [successUpdateDeclaracionJuradaCeseActividadObjetivaById, setSuccessCreateDeclaracionJuradaCeseActividadObjetiva] = useState(false);
  const [errorUpdateDeclaracionJuradaCeseActividadObjetivaById, setErrorCreateDeclaracionJuradaCeseActividadObjetiva] = useState(null);
  const [dataUpdateDeclaracionJuradaCeseActividadObjetivaById, setDataDeclaracionJuradaCeseActividadObjetiva] = useState(null);

  const BASE_URL = import.meta.env.VITE_REACT_APP_PRESTACIONES_PACIENTE_PATH || "";
  const FUNCTIONS_KEY = import.meta.env.VITE_REACT_APP_PRESTACIONES_PACIENTE_KEY || "";
  const apiRecord = new record.RecordService(
    BASE_URL,
    FUNCTIONS_KEY
  )


  //UPDATE
  const updateDeclaracionJuradaCeseActividadObjetivaById = async (userId:string , formId: string, data:any, _cb?:(data:any)=>void) => {
    setLoadingCreateDeclaracionJuradaCeseActividadObjetiva(true);
    setSuccessCreateDeclaracionJuradaCeseActividadObjetiva(false);
    setErrorCreateDeclaracionJuradaCeseActividadObjetiva(null);

    apiRecord.updateSolicitudDeclaracionJuradaObjetivaByID(userId, formId, data).then((res: any) => {
      setLoadingCreateDeclaracionJuradaCeseActividadObjetiva(false);
      setSuccessCreateDeclaracionJuradaCeseActividadObjetiva(true);
      setDataDeclaracionJuradaCeseActividadObjetiva(res.data);
      if (typeof _cb === "function") {
        _cb(res.data);
      }

    }).catch((err:any) => {
      console.log(err)
      setLoadingCreateDeclaracionJuradaCeseActividadObjetiva(false);
      setErrorCreateDeclaracionJuradaCeseActividadObjetiva(err.response.data)
    })
  }

  return {
    updateDeclaracionJuradaCeseActividadObjetivaById,
    loadingUpdateDeclaracionJuradaCeseActividadObjetivaById,
    successUpdateDeclaracionJuradaCeseActividadObjetivaById,
    errorUpdateDeclaracionJuradaCeseActividadObjetivaById,
    dataUpdateDeclaracionJuradaCeseActividadObjetivaById
  }

}

export default useUpdateDeclaracionJuradaCeseActividadObjetivaByID;
